import React from "react";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import ProjectBySlugPage from "~/src/components/project/pages/ProjectBySlugPage";

export default function ProjectPage() {
  return (
    <NavbarLayout>
      <ProjectBySlugPage />
    </NavbarLayout>
  );
}
